import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Insights from "./pages/Insights";
import WhatIsAIAgent from "./pages/WhatIsAIAgent";
import SecuringCloudAIAgents from "./pages/SecuringCloudAIAgents";
import ArchitectureAgenticAI from "./pages/ArchitectureAgenticAI";
import NotFound from "./pages/NotFound";

// Routers and HelmetProvider are supplied by main.tsx (browser) and
// entry-server.tsx (build-time prerender).
function App() {
  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/what-is-an-ai-agent" element={<WhatIsAIAgent />} />
            <Route path="/insights/securing-cloud-applications-ai-agents" element={<SecuringCloudAIAgents />} />
            <Route path="/insights/architecture-of-agentic-ai-systems" element={<ArchitectureAgenticAI />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;
